import React, { useState } from 'react';
import MainNavigation from '../../components/ui/MainNavigation';
import FeaturedBrandSection from '../../components/FeaturedBrandSection';
import ComparisonModal from '../../components/ComparisonModal';
import HeroSection from './components/HeroSection';
import HowItWorksSection from './components/HowItWorksSection';
import HeatPumpTypesSection from './components/HeatPumpTypesSection';
import HomeSuitabilitySection from './components/HomeSuitabilitySection';
import CostsSubsidiesSection from './components/CostsSubsidiesSection';
import ProvidersReviewsSection from './components/ProvidersReviewsSection';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from '../../components/AppIcon';

const HeatPumpCategoryPage = () => {
  const [comparisonProducts, setComparisonProducts] = useState([]);
  const [isComparisonOpen, setIsComparisonOpen] = useState(false);

  const handleAddToCompare = (product) => {
    setComparisonProducts((prev) => {
      const exists = prev?.find(p => p?.id === product?.id);
      if (exists) {
        return prev;
      }
      if (prev?.length >= 3) {
        return [...prev?.slice(1), product];
      }
      return [...prev, product];
    });
  };

  const featuredBrandData = {
    brandName: "Daikin Altherma",
    brandLogo: "https://ui-avatars.com/api/?name=Daikin&background=3b82f6&color=fff&size=80",
    brandDescription: "Marktleider in warmtepomp technologie",
    productName: "Daikin Altherma 3 H HT",
    productImage: "/assets/images/Untitled-1768596855661.jpeg",
    productImageAlt: "Daikin Altherma warmtepomp unit geïnstalleerd buiten moderne woning met hoge temperatuur capaciteit",
    productDescription: "Hoogtemperatuur lucht-water warmtepomp met uitstekende prestaties tot -25°C. Ideaal voor bestaande woningen.",
    productSpecs: [
      { icon: "Thermometer", label: "Vermogen", value: "16 kW" },
      { icon: "TrendingUp", label: "SCOP", value: "4.6" },
      { icon: "Snowflake", label: "Min. temp", value: "-25°C" },
      { icon: "Shield", label: "Garantie", value: "7 jaar" }
    ],
    productPrice: "€12.500",
    rating: 4.8,
    reviewCount: 289,
    reviews: [
      {
        rating: 5,
        text: "Onze energierekening is met 65% gedaald! De warmtepomp werkt zelfs bij vrieskou perfect. Zeer tevreden.",
        name: "Jan Bakker",
        location: "Groningen",
        avatar: "https://ui-avatars.com/api/?name=Jan+B&background=3b82f6&color=fff",
        verified: true
      },
      {
        rating: 5,
        text: "Stille werking en constant comfortabel. De installatie was professioneel en de app is overzichtelijk.",
        name: "Linda Smit",
        location: "Arnhem",
        avatar: "https://ui-avatars.com/api/?name=Linda+S&background=2563eb&color=fff",
        verified: true
      },
      {
        rating: 4,
        text: "Uitstekende prestaties, ook in de winter. Combinatie met vloerverwarming werkt perfect.",
        name: "Robert Jansen",
        location: "Zwolle",
        avatar: "https://ui-avatars.com/api/?name=Robert+J&background=1d4ed8&color=fff",
        verified: true
      }
    ],
    colorScheme: "from-blue-500/10 to-cyan-500/10",
    accentColor: "text-blue-600",
    bgGradient: "from-blue-50 via-cyan-50 to-sky-100"
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <MainNavigation />
      {/* Main Content with proper spacing for fixed navigation */}
      <main className="pt-16 lg:pt-0 lg:ml-[72px] transition-all duration-300">
        <FeaturedBrandSection {...featuredBrandData} onAddToCompare={handleAddToCompare} />
        {/* Hero Section */}
        <HeroSection />

        {/* How Heat Pump Works */}
        <HowItWorksSection />

        {/* Types of Heat Pumps */}
        <HeatPumpTypesSection />

        {/* Home Suitability */}
        <HomeSuitabilitySection />

        {/* Costs & Subsidies */}
        <CostsSubsidiesSection />

        {/* Providers & Reviews */}
        <ProvidersReviewsSection onAddToCompare={handleAddToCompare} />
      </main>
      {/* Floating Compare Button */}
      <AnimatePresence>
        {comparisonProducts?.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            className="fixed bottom-6 right-6 z-40"
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setIsComparisonOpen(true)}
              className="bg-primary text-white px-6 py-4 rounded-full shadow-2xl flex items-center space-x-3 hover:bg-primary/90 transition-colors"
            >
              <Icon name="GitCompare" size={24} />
              <span className="font-semibold">Vergelijk ({comparisonProducts?.length})</span>
            </motion.button>
          </motion.div>
        )}
      </AnimatePresence>
      {/* Comparison Modal */}
      <ComparisonModal
        isOpen={isComparisonOpen}
        onClose={() => setIsComparisonOpen(false)}
        products={comparisonProducts}
        category="warmtepomp"
      />
    </div>
  );
};

export default HeatPumpCategoryPage;